module.exports = "<div class=\"box\">\r\n    <dk-currency-calculator></dk-currency-calculator>\r\n</div>\r\n\r\n";